/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_No_Speakers_FoundInputs */



/**
* | output |
* | --- |
* | "No speakers found" |
*
* @param {Speakers_No_Speakers_FoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_no_speakers_found = /** @type {((inputs?: Speakers_No_Speakers_FoundInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_No_Speakers_FoundInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun intervenant trouve")
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Lautsprecher gefunden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun relatore trovato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Динамики не найдены")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se encontraron hablantes")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未找到扬声器")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スピーカーが見つかりません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई स्पीकर नहीं मिला")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não foram encontrados alto-falantes")
	return /** @type {LocalizedString} */ ("No speakers found")
});